<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <el-date-picker v-model="timevalue" size="small" type="datetimerange"
                      :picker-options="pickerOptions2" range-separator="至"
                      start-placeholder="开始日期" end-placeholder="结束日期"
                      align="right" value-format="yyyy-MM-dd HH:mm:ss">
      </el-date-picker>
      <div>
        <input-select selectTitle="事件" :selectKey="'event'" :selectData="eventList" @search="searchCardType"/>
      </div>
      <div>
        <input-search placeholder="操作人" @search="search"/>
        <button-export
          :href="exportUrl"
          download="download.xls"
          :beforeDownload="beforeDownload"
          v-if="permissionCodes.indexOf('005011001') !== -1"
          value="导出"/>
      </div>
    </div>
    <table-main :selection="false" :hasOperation="hasOperation" :tableHead="tableHead" :tableData="tableData" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" />
  </div>
</template>

<script>
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import InputDatePicker from '../../../components/Input/InputDatePicker'
import InputSearch from '../../../components/Input/InputSearch'
import TableMain from '../../../components/Table/TableMain'
import ButtonExport from '../../../components/Button/ButtonExport'
import {api} from '../../api/ElectronicManagement'
import {errorHandler} from '../../../utils/errorHandler'
import InputSelect from '../../../components/Input/InputSelect'
import {bus} from '../../../utils/bus'

export default {
  components: {
    InputSelect,
    ButtonExport,
    TableMain,
    InputSearch,
    InputDatePicker,
    Breadcrumb},
  name: 'log',
  data () {
    return {
      breadcrumb: [{
        value: '资源中心',
        name: 'business-management'
      }, {
        value: '操作日志'
      }],
      selectTitle: '租赁状态',
      selection: false,
      hasOperation: false,
      pickerOptions2: {
        disabledDate (time) {
          return time.getTime() > new Date(((new Date) / 1000 + 86400) * 1000)
        },
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      exportUrl: '',
      timevalue: [],
      eventList: [{
        key: '',
        label: '全部'
      }, {
        key: '新增',
        label: '新增'
      }, {
        key: '删除',
        label: '删除'
      }, {
        key: '修改',
        label: '修改'
      }, {
        key: '导入',
        label: '导入'
      }],
      tableHead: [{
        prop: 'operateName',
        label: '操作人'
      }, {
        prop: 'event',
        label: '操作事件'
      }, {
        prop: 'description',
        label: '操作内容'
      }, {
        prop: 'operateTime',
        label: '操作时间'
      }],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      requestData: {
        searchKey: '',
        startTime: '',
        endTime: '',
        module: '',
        event: ''
      }
    }
  },
  created () {
    this.getCreatTime()
  },
  methods: {
    beforeDownload () {
      this.exportUrl = `${api.exportLog}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${this.requestData.searchKey}&startTime=${this.requestData.startTime}&endTime=${this.requestData.endTime}&module=${this.requestData.module}&event=${this.requestData.event}`
    },
    getCreatTime () {
      let nowDate = new Date
      let year = nowDate.getFullYear()
      let month = (nowDate.getMonth() + 1) < 10 ? '0' + (nowDate.getMonth() + 1) : (nowDate.getMonth() + 1)
      let date = nowDate.getDate()
      let hour = nowDate.getHours() < 10 ? '0' + nowDate.getHours() : nowDate.getHours()
      let minute = nowDate.getMinutes() < 10 ? '0' + nowDate.getMinutes() : nowDate.getMinutes()
      let second = nowDate.getSeconds() < 10 ? '0' + nowDate.getSeconds() : nowDate.getSeconds()
      this.timevalue[0] = year + '-' + month + '-01' + ' ' + '00:00:00'
      this.timevalue[1] = year + '-' + month + '-' + date + ' ' + hour + ':' + minute + ':' + second
      this.getPage()
    },
    changePagination (data) {
      this.pageNum = data[0]
      this.pageSize = data[1]
      this.getPage()
    },
    searchCardType (v) {
      this.pageNum = 1
      this.requestData.event = v.value
      this.getPage()
    },
    search (v) {
      this.pageNum = 1
      this.requestData.searchKey = v
      this.getPage()
    },
    getPage () {
      let reqData = this.requestData
      reqData.pageNum = this.pageNum
      reqData.pageSize = this.pageSize
      if (this.timevalue) {
        this.requestData.startTime = this.timevalue[0]
        this.requestData.endTime = this.timevalue[1]
      } else {
        this.requestData.startTime = ''
        this.requestData.endTime = ''
      }
      this.$axios.post(api.getElectricLogPage, reqData)
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list
            this.total = res.data.data.total
            // data.map((v, i) => {
            //   if (v.parentCode === '0') {
            //     data.splice(i, 1)
            //   }
            // })
            this.tableData = data
          }
        })
        .catch(errorHandler('获取操作记录失败'))
    },
  },
  watch: {
    timevalue (val) {
      this.getPage()
    }
  }
}
</script>

<style scoped>
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .main-btn {
    color: #FFFFFF;
    background-color: #00A0E6;
    border: none;
  }
  .main-btn:hover {
    color: #FFFFFF;
    background-color: #06b3ff;
    border: none;
  }
</style>



// WEBPACK FOOTER //
// src/view/ElectronicManagement/ElectrinicLog/ElectronicLog.vue